'use client'

// The public visitor hook. All state and operations live in VisitorProvider;
// this is the one import surface components use. Identity display/capability
// gating on desks stays with the server-derived AccessGrant — the visitor
// describes who is acting and owns the entry/leave UI operations.

import { useVisitorContext, type VisitorValue } from './VisitorProvider'

export type { VisitorValue }

export function useVisitor(): VisitorValue {
  return useVisitorContext()
}
